module.exports = __webpack_public_path__ + "media/images/design/images/arrows/slider_arrow_left-c7e6d4d5ca3225cda371a4f03dc39e35.png";